const styles = (theme) => ({
  publishDialog: {
    padding: "18px 24px",
    boxSizing: "border-box",
    borderRadius: "2px",
    backgroundColor: theme.ModalBGColor,
    boxShadow: "2px 2px 4px black",
  },
  publishDialogTitle: {
    fontSize: theme.headerTextFontSize,
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.dispatchPanelLabelValueColor,
    padding: 0,
  },
  publishDialogContent: {
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    overflow: "hidden",
    padding: "16px 0px",
  },
  dialogButtonStyle: {
    fontSize: theme.textFontSize,
    textTransform: "none",
    borderRadius: "2px",
    margin: 0,
  },
  boldFont: {
    marginTop: 10,
    fontWeight: 600,
  },
  tableHeaderCell: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelLabelValueColor,
    fontWeight: 600,
    padding: 0,
    paddingLeft: "14px",
    backgroundColor: theme.AppBGColor,
  },
  tableDataCell: {
    fontSize: theme.textFontSize,
    padding: 0,
    paddingLeft: "14px",
    color: theme.gridTextColor,
  },
  tableRow: {
    height: "30px",
  },
  tableHead: {},
  tableHeadHeight: {
    height: "40px",
  },
  tableHeadCell: {
    color: theme.palette.primary.main,
    fontSize: theme.headerTextFontSize,
    paddingLeft: "14px",
  },
  tableRoot: {
    border: `1px solid ${theme.AppBGColor}`,
    margin: "15px 0",
  },
  link: {
    cursor: "pointer",
    textDecoration: "underline"
  }
});

export default styles